import { render } from "./PriceList.vue?vue&type=template&id=51a31544&scoped=true"
import script from "./PriceList.vue?vue&type=script&lang=js"
export * from "./PriceList.vue?vue&type=script&lang=js"

import "./PriceList.vue?vue&type=style&index=0&id=51a31544&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a31544"]])

export default __exports__